import map from 'lodash/map';
import filter from 'lodash/filter';
import indexOf from 'lodash/indexOf';

import {
  GET_SINKS_SUCCESS,
  GET_SINKS_FAILURE,
  GET_SINK_SUCCESS,
  ADD_SINK_SUCCESS,
  COPY_SINK_SUCCESS,
  DELETE_SINK_SUCCESS,
  DELETE_PIPELINE_SUCCESS,
  LOGOUT_COMPLETE,
} from '../../constants/actionTypes';

const initialState = {
  lastUpdated: null,
  byId: [],
  lastAddedId: null,
  error: null,
};

export const sinksReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SINKS_SUCCESS:
      return saveSinks(state, action);

    case GET_SINKS_FAILURE:
      return removeSinks(state, action);

    case GET_SINK_SUCCESS:
      return saveSink(state, action);

    case ADD_SINK_SUCCESS:
    case COPY_SINK_SUCCESS:
      return addSink(state, action);

    case DELETE_SINK_SUCCESS:
      return deleteSink(state, action);

    case DELETE_PIPELINE_SUCCESS:
      return deletePipeline(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

export default sinksReducer;

function saveSinks(state, action) {
  let { result } = action;

  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: result,
    error: null,
  };
}

function saveSink(state, action) {
  let { result } = action;

  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: indexOf(state.byId, result) === -1 ? [...state.byId, result] : [...state.byId],
    error: null,
  };
}

function addSink(state, action) {
  let { result } = action;

  return {
    ...state,
    byId: indexOf(state.byId, result) ? [...state.byId, result] : [...state.byId],
    lastAddedId: result,
    lastUpdated: action.receivedAt,
    error: null,
  };
}

function removeSinks(state, action) {
  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: [],
    error: action.error,
  };
}

function deleteSink(state, action) {
  let {
    requestInfo: { id },
  } = action;
  let deletedSinkId = id;
  let newById = filter(state.byId, (sId) => sId !== deletedSinkId);

  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: newById,
    error: null,
  };
}

function deletePipeline(state, action) {
  let {
    requestInfo: { deletedItems },
  } = action;
  let deletedSinkIds = map(
    filter(deletedItems, (item) => item.type === 'DATA_SINK'),
    'data_sink_id',
  );
  let newById = filter(state.byId, (sId) => !deletedSinkIds.includes(sId));

  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: newById,
    error: null,
  };
}
